/*******
* Start of Nutshell
* https://tree.taiga.io/project/coolminds-nutshell/
*******/

/*******
 * Register a service worker
 *
 * navigator.serviceWorker.register only register the serviceworker and activate it.
 * but to get controller over the serviceworker you need to put your serviceworker in the
 * public root folder so that all the pages will be in the
 * scope and service worker will be attached to it.
 *
 * So rewrite /res/assets/dist/js/sw.js -> /sw.js in the .htaccess
 *
 * The page will be refreshed if the service worker is out of date.
 * Update the const VERSION in the sw.js file to archive this effect.
 *
 *******/

 if ('serviceWorker' in navigator) {

     window.addEventListener('load', function() {

         navigator.serviceWorker.register('/sw.js').then( (registration) => {

             window.serviceRegistration = registration;

             registration.addEventListener('updatefound', () => {

                 if (registration.installing) {

                    //Wait until the new Service worker is actually installed (ready to take over)
                    registration.installing.addEventListener('statechange', () => {

                        if (registration.waiting) {

                            //If there's an existing controller (previous Service Worker), show the prompt
                            if (navigator.serviceWorker.controller) {

                                console.log('[Service Worker] - Show notification. Old service worker');

                            } else {
                                console.log('[Service Worker] - Service Worker initialized for the first time')
                            }
                        }
                    })
                 }

                 let refreshing = false;

                 //Detect controller change and refresh the page
                 navigator.serviceWorker.addEventListener('controllerchange', () => {

                    console.log('[Service Worker] - Refresh service worker');

                    if (!refreshing) {

                         console.log('[Service Worker] - Show notification. Old service worker');

                         window.location.reload()
                         refreshing = true
                     }
                 });

             });

         }).catch((e) => {});

    });
 }

/*******
* Importing project
*******/
import "./application";
